<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1>新建园点</h1>
        <span class="icon-right pull-right orange" @click="registerMsg()">提交</span>
      </div>
      <div class="liner"></div>
    </div>


    <div class="main-page">
      <div>
        <p class="margin-15">红色“*”为必填项，请认真填写。</p>
        <ul class="list-group-item tinny">
          <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix  group-txt">
              <span class="pull-left">姓名：</span><i class="red must">*</i>
              <span class="pull-right gray"><input class="text-right font-14" type="text" placeholder="请输入" v-model="teacherName"></span>
            </div>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix  group-txt">
              <span class="pull-left">身份证号：</span><i class="red must">*</i>
              <span class="pull-right gray"><input class="text-right font-14" type="text" placeholder="请输入" v-model="sfzNum"></span>
            </div>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix  group-txt">
              <span class="pull-left">园点名称：</span><i class="red must">*</i>
              <span class="pull-right gray"><input class="text-right font-14" type="text" placeholder="请输入" v-model="curcheName"></span>
            </div>
          </li>
          </ul>
          <!-- <li class="list-group">
            <div class="liner"></div>
            <label class="clearfix group-txt img-more forselect" for="citySelect">
              <span class="pull-left">所在城市：</span><i class="red must">*</i>
              <span class="pull-right margin-x-15 gray font-12">{{city}}</span>
              <span class="selectbar">
                <select id="citySelect" v-model="city" @change="citySelected($event)">
                  <option v-for="item in cityInfo" v-bind:value="item.cityName" v-bind:id="item.cityId">{{item.cityName}}</option>
                </select>
              </span>
            </label>
          </li> -->
          <ul class="list-group-item tinny">
          <li>
            <div class="liner"></div>
            <div  class="clearfix  group-txt">
              <span class="pull-left">所在城市：<i class="red must">*</i></span>
              <label class="clearfix forselect text-right" style="float:right;margin-left:15px" for="citySelect">
                <span class="gray" @click="dialogObj.city = true">{{city}}</span>
                <span class="selectbar">
                  <!-- <select id="citySelect" v-model="city" @change="citySelected($event)">
                  <option value='请选择'>请选择</option>
                  <option v-for="item in cityInfo" v-bind:value="item.cityName" v-bind:id="item.cityId">{{item.cityName}}</option>
                </select> -->
                </span>
              </label>
              <label class="clearfix forselect margin-x-15 text-right" style="float:right" for="proSelect">
                <span class="gray" @click="dialogObj.pro = true">{{pro}}</span>
                <span class="selectbar">
                  <!-- <select id="proSelect" v-model="pro" @change="proSelected($event)">
                    <option value='请选择'>请选择</option>
                    <option v-for="item in proInfo" v-bind:value="item.provinceName" v-bind:id="item.provinceId">{{item.provinceName}}</option>
                  </select> -->
                </span>
              </label>
            </div>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <label class="clearfix group-txt img-more forselect" for="areaSelect">
              <span class="pull-left">所在区：</span><i class="red must">*</i>
              <span class="pull-right margin-x-15 gray" @click="dialogObj.area = true">{{area}}</span>
              <span class="selectbar">
                <!-- <select id="areaSelect" v-model="area" @change="areaSelected($event)">
                  <option value='请选择'>请选择</option>
                  <option v-for="item in areaInfo" v-bind:value="item.areaName" v-bind:id="item.areaId">{{item.areaName}}</option>
                </select> -->
              </span>
            </label>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix  group-txt">
              <span class="pull-left">地址：</span><i class="red must pull-left">*</i>
              <span class="block gray" style="margin-left:60px"><input class="text-right font-12" style="width:100%" type="text" placeholder="请输入详细地址" v-model="detailAddress"></span>
            </div>
          </li>
          </ul>
          <ul class="list-group-item tinny">
          <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix  group-txt">
              <span class="pull-left">服务学校：</span><i class="red must">*</i>
              <span class="pull-right gray"><input class="text-right font-14" type="text" placeholder="请输入" v-model="serviceSchool"></span>
            </div>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix  group-txt">
              <span class="pull-left">园点电话：</span><i class="red must">*</i>
              <span class="pull-right gray"><input class="text-right font-14" type="number" placeholder="请输入" v-model='phoneNumber'></span>
            </div>
          </li>
        </ul>

        <span class="block margin-15">您的身份证正反面<span class="gray font-12">（可不填）</span></span>
        <div class="add-pic">
          <ul class="list-group-item clearfix">
            <li v-for="(image, index) in IDPhotoList">
              <div>
                <img :src="image.baseAcessPath + image.imageAddress" width="80" height="80" /><span class="del" @click="delImage(index, IDPhotoList)">删除</span>
              </div>
            </li>
            <li v-if="IDPhotoList.length < 2">
              <div>
                <div class="button-add" @click="capturePhoto(IDPhotoList, 4);" v-if="isAndroid"></div>
                <div class="button-add" v-else>
                  <form enctype="multipart/form-data" method="post" name="fileinfo">
                    <input type="file" name="pic" id="pic" accept="image/*" multiple="multiple" size="1" @change="updateImage(IDPhotoList, 2)"/>
                  </form>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <span class="block margin-15">资质证明或运营许可证<span class="gray font-12">（可不填）</span></span>
        <div class="add-pic">
          <ul class="list-group-item clearfix">
            <li v-for="(image, index) in certificateList">
              <div>
                <img :src="image.baseAcessPath + image.imageAddress" width="80" height="80" /><span class="del" @click="delImage(index, certificateList)">删除</span>
              </div>
            </li>
            <li v-if="certificateList.length < 1">
              <div>
                <div class="button-add" @click="capturePhoto(certificateList, 4);" v-if="isAndroid"></div>
                <div class="button-add" v-else>
                  <form enctype="multipart/form-data" method="post" name="fileinfo">
                    <input type="file" name="pic" id="pic" accept="image/*" multiple="multiple" size="1" @change="updateImage(certificateList, 1)"/>
                  </form>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <span class="block margin-15">园点照片，最多4张<span class="gray font-12">（可不填）</span></span>
       <div class="add-pic">
          <ul class="list-group-item clearfix">
            <li v-for="(image, index) in curcheImageList">
              <div>
                <img :src="image.baseAcessPath + image.imageAddress" width="80" height="80" /><span class="del" @click="delImage(index, curcheImageList)">删除</span>
              </div>
            </li>
            <li v-if="curcheImageList.length < 4">
              <div>
                <div class="button-add" @click="capturePhoto(curcheImageList, 4);" v-if="isAndroid"></div>
                <div class="button-add" v-else>
                  <form enctype="multipart/form-data" method="post" name="fileinfo">
                    <input type="file" name="pic" id="pic" accept="image/*" multiple="multiple" size="1" @change="updateImage(curcheImageList, 4)"/>
                  </form>
                </div>
              </div>
            </li>
          </ul>
        </div>
    </div>

    <!-- 选择省份 -->
    <div class="maskdiv" v-show="dialogObj.pro" @click="dialogObj.pro = false">
      <div class="slider">
        <strong class="tit">选择省份</strong>
        <div class="liner"></div>
        <div class="list-group-item tinny">
          <ul v-for="item in proInfo">
            <li @click="proSelected(item)">
              <div class="clearfix group-link"><span class="pull-left">{{item.provinceName}}</span>
              <template v-if="item.provinceId == proId">
                <i class="pull-right img-checkbox checked"></i>
              </template>
              <template v-else>
                <i class="pull-right img-checkbox"></i>
              </template>
              </div>
              <div class="liner"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 选择城市 -->
    <div class="maskdiv" v-show="dialogObj.city" @click="dialogObj.city = false">
      <div class="slider">
        <strong class="tit">选择城市</strong>
        <div class="liner"></div>
        <div class="list-group-item tinny">
          <ul v-for="item in cityInfo">
            <li @click="citySelected(item)">
              <div class="clearfix group-link"><span class="pull-left">{{item.cityName}}</span>
              <template v-if="cityId == item.cityId">
                <i class="pull-right img-checkbox checked"></i>
              </template>
              <template v-else>
                <i class="pull-right img-checkbox"></i>
              </template>
              </div>
              <div class="liner"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 选择地区 -->
    <div class="maskdiv" v-show="dialogObj.area" @click="dialogObj.area = false">
      <div class="slider">
        <strong class="tit">选择地区</strong>
        <div class="liner"></div>
        <div class="list-group-item tinny">
          <ul v-for="item in areaInfo">
            <li @click="areaSelected(item)">
              <div class="clearfix group-link"><span class="pull-left">{{item.areaName}}</span>
              <template v-if="areaId == item.areaId">
                <i class="pull-right img-checkbox checked"></i>
              </template>
              <template v-else>
                <i class="pull-right img-checkbox"></i>
              </template>
              </div>
              <div class="liner"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <mt-popup 
    v-model="popupVisebleHostcenter" 
    position="bottom">
    <div>
      <div class="padding-15">
        <p  class="font-16 text-center orange">温馨提示</p>
        <p class="margin-15">如果您是园点老师，请园长邀请您加入即可，无须申请入驻哦！</p>
        <p class="margin-15">如果您是园长，且您的园点还未入驻少儿之家APP，请填写资料申请入驻哦！</p>
        <p class="margin-15 gray">园点审核通过后7天内如果学生数为零，园点将被自动关闭</p>
      </div>
      <div class="liner"></div>
      <span class="block text-center padding-15" @click="popupVisebleHostcenter = false">我知道了</span>
    </div>
    </mt-popup>
  </div>
</template>

<script>
import { service, uploadMulUrl } from '../../service'
import { Toast, Indicator } from 'mint-ui'
export default {
  data () {
    return {
      login_data: JSON.parse(window.localStorage['login_data']),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      get_Pro_Msg_Para: service.setPara('getPro'),
      get_City_Msg_Para: service.setPara('getNewCity'),
      get_Area_Msg_Para: service.setPara('getArea'),
      teacher_or_dudao_register_Para: service.setPara('register'),
      proInfo: {},
      cityInfo: {},
      areaInfo: {},
      curcheName: '',
      teacherId: 0,
      teacherName: '',
      sfzNum: '',
      detailAddress: '',
      serviceSchool: '',
      phoneNumber: '',
      studentNumber: '',
      gzryNum: '',
      proId: 0,
      pro: '请选择',
      cityShow: '',
      cityId: 0,
      city: '请选择',
      areaId: 0,
      area: '',
      IDPhotoList: [], // 身份证照片列表
      certificateList: [], // 资质证明列表
      curcheImageList: [], // 园点照片
      popupVisebleHostcenter: false, // 进入弹出默认文字
      isAndroid: true,
      nowImageList: [],
      nowImageLimitLength: 0,
      dialogObj: {pro: false, city: false, area: false}
    }
  },
  mounted: function () {
    let b = window.browser()
    this.isAndroid = b.android

    this.getProMsg()
    this.popupVisebleHostcenter = true
  },
  methods: {
    getProMsg: function () { // 获取省份数据
      this.get_Pro_Msg_Para.randomPara = 123

      let that = this
      let obj = {context: this, para: this.get_Pro_Msg_Para, successFun: (response) => {
        that.proInfo = response.data
      }}
      service.request(obj)
    },
    getCityMsg: function () { // 获取城市
      if (this.pro == '请选择') {
        return
      }
      this.get_City_Msg_Para.randomPara = 123
      this.get_City_Msg_Para.provinceId = this.proId

      let that = this
      let obj = {context: this, para: this.get_City_Msg_Para, successFun: (response) => {
        that.cityInfo = response.data
      }}
      service.request(obj)
    },
    getAreaMsg: function () { // 获取地区
      if (this.city == '请选择') {
        return
      }
      this.get_Area_Msg_Para.cityId = this.cityId

      let that = this
      let obj = {context: this, para: this.get_Area_Msg_Para, successFun: (response) => {
        that.areaInfo = response.data
      }}
      service.request(obj)
    },
    proSelected: function (item) {
      this.proId = item.provinceId
      this.pro = item.provinceName
      this.dialogObj.pro = false
      this.getCityMsg()
      this.city = '请选择'
      this.area = '请选择'
      this.areaInfo = []
      this.areaId = ''
      this.cityInfo = []
      this.cityId = ''
      /* for (var i = 0; i < obj.currentTarget.length; i++) {
        if (obj.currentTarget[i].selected) {
          this.proId = parseInt(obj.currentTarget[i].id)
          this.pro = obj.currentTarget[i].value
          this.getCityMsg()
          this.city = '请选择'
          this.area = '请选择'
          this.areaInfo = []
        }
      } */
    },
    citySelected: function (item) {
      this.cityId = item.cityId
      this.city = item.cityName
      this.dialogObj.city = false
      this.getAreaMsg()
      this.area = '请选择'
      this.areaInfo = []
      this.areaId = ''
      // for (var i = 0; i < obj.currentTarget.length; i++) {
      //   if (obj.currentTarget[i].selected) {
      //     this.cityId = parseInt(obj.currentTarget[i].id)
      //     this.city = obj.currentTarget[i].value
      //     this.getAreaMsg()
      //     this.area = '请选择'
      //   }
      // }
    },
    areaSelected: function (item) {
      this.areaId = item.areaId
      this.area = item.areaName
      this.dialogObj.area = false
      // for (var i = 0; i < obj.currentTarget.length; i++) {
      //   if (obj.currentTarget[i].selected) {
      //     this.areaId = parseInt(obj.currentTarget[i].id)
      //     this.area = obj.currentTarget[i].value
      //   };
      // };
    },
    updateImage: function (listPara, quantities) {
      var imageLength = document.getElementById('pic').files.length
      if (imageLength === 0) {
        return
      }

      if (imageLength + listPara.length > quantities) {
        Toast('最多只能再上传' + (quantities - listPara.length) + '张图片')
        return
      }

      let that = this
      let data = new window.FormData()
      let nowLength = 0
      for (let i = 0; i < imageLength; i++) {
        lrz(document.getElementById('pic').files[i], {width: 1024})
        .then(function (rst) {
          data.append('pic', rst.file, rst.origin.name)
          nowLength++
          if (nowLength == imageLength) {
            let url = uploadMulUrl + that.cookie_login_data.phoneNum + '&needThumb=1'

            let obj = {context: that, para: data, url: url, successFun: (response) => {
              for (var i = 0; i < response.data.length; i++) {
                var imageInfo = {}
                imageInfo.baseAcessPath = response.data[i].image.baseAcessPath
                imageInfo.imageAddress = response.data[i].image.thumbFilePath
                imageInfo.srcFilePath = response.data[i].image.srcFilePath
                listPara.push(imageInfo)
              }
            }}
            service.request(obj)
          }
        })
      }
    },
    delImage: function (index, listPara) {
      listPara.splice(index, 1)
    },
    registerMsg: function () {
      if (this.teacherName === '') {
        Toast('请输入老师姓名')
        return
      }
      if (this.sfzNum === '') {
        Toast('请输入身份证号码')
        return
      }
      if (this.curcheName === '') {
        Toast('请输入园点名称')
        return
      }
      if (this.pro === '请选择') {
        Toast('请选择所在省份')
        return
      }
      if (this.city === '请选择') {
        Toast('请选择所在城市')
        return
      }
      if (this.area === '请选择') {
        Toast('请选择所在区')
        return
      }
      if (this.detailAddress === '') {
        Toast('请输入地址')
        return
      }
      if (this.serviceSchool === '') {
        Toast('请输入服务学校')
        return
      }
      if (this.phoneNumber === '') {
        Toast('请输入园点电话')
        return
      }
      /* if (this.IDPhotoList.length < 2) {
        Toast('请上传身份证图片')
        return
      }
      if (this.certificateList.length < 1) {
        Toast('请上传资质证明或运营许可证')
        return
      }
      if (this.curcheImageList.length < 2) {
        Toast('请上传至少两张园点照片')
        return
      } */
      this.teacher_or_dudao_register_Para.teacherName = this.teacherName
      this.teacher_or_dudao_register_Para.sfzNum = this.sfzNum
      // this.teacher_or_dudao_register_Para.jobCode = this.login_data[this.cookie_login_data.index].jobCode
      this.teacher_or_dudao_register_Para.jobCode = 'teacher'
      this.teacher_or_dudao_register_Para.curcheName = this.curcheName
      this.teacher_or_dudao_register_Para.provinceId = this.proId
      this.teacher_or_dudao_register_Para.cityId = this.cityId
      this.teacher_or_dudao_register_Para.areaId = this.areaId
      this.teacher_or_dudao_register_Para.curcheAddress = this.detailAddress
      this.teacher_or_dudao_register_Para.serviceSchool = this.serviceSchool
      this.teacher_or_dudao_register_Para.curchePhone = $.trim(this.phoneNumber)
      this.teacher_or_dudao_register_Para.dqxsNum = this.studentNumber
      this.teacher_or_dudao_register_Para.gzryNum = this.gzryNum
      if (this.certificateList.length > 0) {
        this.teacher_or_dudao_register_Para.businessImage = this.certificateList[0].srcFilePath
      }

      if (this.IDPhotoList.length > 1) {
        this.teacher_or_dudao_register_Para.sfzFrontImg = this.IDPhotoList[0].srcFilePath
      }

      if (this.IDPhotoList.length > 2) {
        this.teacher_or_dudao_register_Para.sfzOppoImg = this.IDPhotoList[1].srcFilePath
      }
      this.teacher_or_dudao_register_Para.teacherId = this.cookie_login_data.teacherId
      this.teacher_or_dudao_register_Para.phoneNum = this.cookie_login_data.phoneNum
      var curcheImageArr = []
      for (var i = 0; i < this.curcheImageList.length; i++) {
        curcheImageArr.push(this.curcheImageList[i].srcFilePath)
      }

      if (curcheImageArr.length > 0) {
        this.teacher_or_dudao_register_Para.curcheImgs = curcheImageArr
      }

      let obj = {context: this, para: this.teacher_or_dudao_register_Para, successFun: (response) => {
        Indicator.close()
        // Toast(response.msg)
        // window.history.go(-1)
        this.$router.push('/chooseRole')
      }, not100CodeFun: (response) => {
        Indicator.close()
        Toast(response.msg)
        window.history.go(-1)
      }}
      service.request(obj)
    },
    capturePhoto: function (nowImageList, nowImageLimitLength) {
      this.nowImageList = nowImageList
      this.nowImageLimitLength = nowImageLimitLength
      Indicator.open()
      navigator.camera.getPicture(this.onPhotoDataSuccess, this.onFail, { quality: 50, destinationType: navigator.camera.DestinationType.DATA_URL, sourceType: navigator.camera.PictureSourceType.PHOTOLIBRARY, targetWidth: 1000, targetHeight: 2000 })
    },
    onPhotoDataSuccess: function (imageData) {
      let imgData = 'data:image/jpeg;base64,' + imageData
      let f = {}
      f.file = this.dataURLtoBlob(imgData)
      f.name = '0.png'

      var data = new window.FormData()
      data.append('pic', f.file, f.name)
      let url = uploadMulUrl + this.cookie_login_data.phoneNum + '&needThumb=1'
      let obj = {context: this, para: data, url: url, successFun: (response) => {
        for (var i = 0; i < response.data.length; i++) {
          var imageInfo = {}
          imageInfo.baseAcessPath = response.data[i].image.baseAcessPath
          imageInfo.imageAddress = response.data[i].image.thumbFilePath
          imageInfo.srcFilePath = response.data[i].image.srcFilePath
          this.nowImageList.push(imageInfo)
          Indicator.close()
        }
      }}
      service.request(obj)
    },
    onFail: function (message) {
      Indicator.close()
      // alert('Failed because: ' + message)
    },
    dataURLtoBlob: function (dataurl) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = window.atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new window.Blob([u8arr], {type: mime})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// hostTeacherRegister.vue?d7f260ae